/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CalculatePremiumFundingDto = {
    /**
     * Payment frequency for the instalment schedule
     */
    paymentFrequency: CalculatePremiumFundingDto.paymentFrequency;
    /**
     * Start date for payments (YYYY-MM-DD)
     */
    paymentStartDate: string;
};
export namespace CalculatePremiumFundingDto {
    /**
     * Payment frequency for the instalment schedule
     */
    export enum paymentFrequency {
        FORTNIGHTLY = 'fortnightly',
        MONTHLY = 'monthly',
    }
}

